/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addTabla } from 'redux/reducersV2/tablaDimensionesSlice';

interface TablaRubricaState {
	key: string;
	isSaved: boolean;
	isDirty: boolean;
	isPuntaje?: boolean;
}
// { isSaved: false, isDirty: false };
const initialState: TablaRubricaState[] = [];

const tablaRubricaFilaStatusSlicesSlice = createSlice({
	name: 'tablaRubricaFilaStatus',
	initialState,
	reducers: {
		addTablaRubricaFilaDefaultStatus: (state, action: PayloadAction<string>) => {
			return [...state, { key: action.payload, isSaved: false, isDirty: false }];
		},
		addTablaRubricaPuntajeFilaDefaultStatus: (state, action: PayloadAction<string>) => {
			return [...state, { key: action.payload, isSaved: false, isDirty: false, isPuntaje: true }];
		},
		setSavedTablaRubricaFilaStatus: (state, action: PayloadAction<string>) => {
			const index = state.findIndex((status) => status.key === action.payload);
			if (index !== -1) {
				state[index].isSaved = true;
				state[index].isDirty = false;
			}
		},
		setDirtyTablaRubricaFilaStatus: (state, action: PayloadAction<string>) => {
			const index = state.findIndex((status) => status.key === action.payload);
			if (index !== -1) {
				state[index].isSaved = false;
				state[index].isDirty = true;
			}
		},
		setAllSavedTablaRubricaFilaStatus: (state) => {
			state.forEach((status) => {
				status.isSaved = true;
				status.isDirty = false;
			});
		},
		removeTablaRubricaFilaStatus: (state, action: PayloadAction<string>) => {
			return state.filter((status) => status.key !== action.payload);
		},
		resetAllTablaRubricaFilaStatus: () => {
			return initialState;
		}
	}
});

export const {
	addTablaRubricaFilaDefaultStatus,
	addTablaRubricaPuntajeFilaDefaultStatus,
	setSavedTablaRubricaFilaStatus,
	setDirtyTablaRubricaFilaStatus,
	removeTablaRubricaFilaStatus,
	resetAllTablaRubricaFilaStatus,
	setAllSavedTablaRubricaFilaStatus
} = tablaRubricaFilaStatusSlicesSlice.actions;

export default tablaRubricaFilaStatusSlicesSlice.reducer;
